import { Component, OnDestroy, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { SharedService } from '../../_services/shared.service';
import { Subject } from 'rxjs';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TranslatedToastService } from '../../_services/translated-toast.service';
import { LifecycleReqDto } from '../../_dtos/lifecycleReqDto';
import { LifecycleService } from '../../_services/lifecycle.service';
import { TeamsService } from '../../_services/teams.service';
import { SitesService } from '../../_services/sites.service';
import { BookingsService } from '../../_services/bookings.service';
import { ResourceTypes } from '../../_enums/resourceTypes';
import { TableDataService } from '../../_services/table-data.service';
import { DeleteSiteOptionsDto } from '../../_dtos/deleteSiteOptionsDto';

@Component({
  selector: 'app-lifecycle-form',
  imports: [ReactiveFormsModule, MatButton, CommonModule, TranslateModule],
  standalone: true,
  templateUrl: './lifecycle-form.component.html',
  styleUrl: './lifecycle-form.component.css',
})
export class LifecycleFormComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  public displayName!: string;
  public endOfLife!: string;
  private id!: string;
  private resourceType!: ResourceTypes;
  private isGroupConnected!: boolean;
  private connectedGroupId!: string;

  constructor(
    private toastr: TranslatedToastService,
    private sharedService: SharedService,
    private lifecycleService: LifecycleService,
    private teamsService: TeamsService,
    private sitesService: SitesService,
    private bookingsService: BookingsService,
    private tableDateService: TableDataService,
  ) {}

  ngOnInit() {
    this.sharedService.lifecycleForm$.subscribe((value) => {
      this.displayName = value!.displayName;
      this.endOfLife = value!.endOfLife;
      this.id = value!.id;
      this.resourceType = value!.resourceType;
      this.isGroupConnected = value!.isGroupConnected;
      this.connectedGroupId = value!.connectedGroupId;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  renewLifecycle() {
    const lifecycleReqDto: LifecycleReqDto = {
      id: this.id,
      resourceType: this.resourceType,
    };
    this.sharedService.closeModal();

    this.lifecycleService.renewLifecycle(lifecycleReqDto).subscribe({
      next: async (res) => {
        await this.toastr.show(
          'success',
          'TOASTS.LIFECYCLE.EXTEND_MESSAGE',
          'TOASTS.LIFECYCLE.EXTEND_TITLE',
        );
        this.tableDateService.notifyResourceUpdate(this.id, {
          resourceStatus: res.resourceStatus,
          endOfLife: res.endOfLife,
        });
      },
    });
  }

  deleteResource() {
    this.sharedService.closeModal();
    if (this.resourceType === ResourceTypes.TEAM) {
      this.teamsService.deleteTeams(this.id).subscribe({
        next: async () => {
          await this.toastr.show(
            'success',
            'TOASTS.RESOURCE.DELETED_MESSAGE',
            'TOASTS.RESOURCE.DELETED_TITLE',
          );
          this.tableDateService.notifyResourceDelete(this.id);
        },
      });
    }
    if (this.resourceType === ResourceTypes.SHAREPOINT) {
      if (this.isGroupConnected) {
        var deleteSiteOptions: DeleteSiteOptionsDto = {
          siteId: this.connectedGroupId,
          isGroupConnected: this.isGroupConnected,
        };
        this.teamsService
          .deleteTeams(this.connectedGroupId, deleteSiteOptions)
          .subscribe({
            next: async () => {
              await this.toastr.show(
                'success',
                'TOASTS.RESOURCE.DELETED_MESSAGE',
                'TOASTS.RESOURCE.DELETED_TITLE',
              );
              this.tableDateService.notifyResourceDelete(this.id);
            },
          });
        // Standard Site Deletion
      } else {
        this.sitesService.deleteSharepoint(this.id).subscribe({
          next: async () => {
            await this.toastr.show(
              'success',
              'TOASTS.RESOURCE.DELETED_MESSAGE',
              'TOASTS.RESOURCE.DELETED_TITLE',
            );
            this.tableDateService.notifyResourceDelete(this.id);
          },
        });
      }
    }
    if (this.resourceType === ResourceTypes.BOOKINGS) {
      this.bookingsService.deleteBooking(this.id).subscribe({
        next: async () => {
          await this.toastr.show(
            'success',
            'TOASTS.RESOURCE.DELETED_MESSAGE',
            'TOASTS.RESOURCE.DELETED_TITLE',
          );
          this.tableDateService.notifyResourceDelete(this.id);
        },
      });
    }
  }
}
